/**
 * `/__ui/collab` — the visual-regression harness for round 5m (the same trick B4's board
 * harness and M5's notifications harness use). It renders with **no session, no api and no
 * database**, so a served build can be hit-tested against
 * `discovery/ui-reference/{my-work,search,subscribers}/*.png`.
 *
 * Three surfaces on one page, selected by `?screen=`:
 *   `my-work` (default) · `search` · `subscribers`
 */
import { useMemo, useState } from 'react';
import { MyWorkPage } from './MyWorkPage';
import { createFixtureMyWorkSource } from './fixture';
import { SearchPanel } from '../search/SearchPanel';
import { createFixtureSearchSource } from '../search/fixture';
import { ItemSubscribers } from '../subscribers/ItemSubscribers';
import { createFixtureSubscribersSource } from '../subscribers/trpc-source';
import './my-work.css';
import '../search/search.css';
import '../subscribers/subscribers.css';

export function CollabHarness() {
  const params = new URLSearchParams(typeof window === 'undefined' ? '' : window.location.search);
  const screen = params.get('screen') ?? 'my-work';
  const myWork = useMemo(() => createFixtureMyWorkSource(), []);
  const search = useMemo(() => createFixtureSearchSource(), []);
  const subscribers = useMemo(
    () =>
      createFixtureSubscribersSource([
        { id: '5000000000001', kind: 'user', name: 'Ada Byron', email: 'ada@example.test', photoUrl: null, title: 'CTO' },
        { id: '5000000000002', kind: 'user', name: 'Grace Hopper', email: 'grace@example.test', photoUrl: null, title: 'Engineer' },
      ]),
    [],
  );
  const [searchOpen, setSearchOpen] = useState(true);

  if (screen === 'search') {
    return (
      <div data-testid="ui-collab-search" style={{ minHeight: '100vh', background: 'var(--layout-background-color)' }}>
        {searchOpen ? (
          <SearchPanel
            source={search}
            onClose={() => setSearchOpen(false)}
            onNavigate={() => undefined}
            initialTerm={params.get('term') ?? ''}
          />
        ) : (
          <button type="button" onClick={() => setSearchOpen(true)} data-testid="search-reopen">
            Reopen
          </button>
        )}
      </div>
    );
  }

  if (screen === 'subscribers') {
    return (
      <div data-testid="ui-collab-subscribers" style={{ minHeight: '100vh', padding: 24 }}>
        {/*
          The 668-wide header the cluster lives in, so the offsets are the measured ones. The
          `maxWidth` is round 7b: at 1440 the fixture is still exactly 668, but on a 390 px phone
          a fixed 668 made the *harness* scroll sideways and put the cluster off-screen, and the
          sweep read that as a product defect (`horizontal-scroll`, `not-clickable`).
        */}
        <div
          className="item-page-header-component"
          style={{
            width: 668,
            maxWidth: '100%',
            height: 82,
            position: 'relative',
            border: '1px solid var(--pane-border-color)',
          }}
        >
          <div style={{ position: 'absolute', top: 4, right: 125 }}>
            <ItemSubscribers itemId="2000000000001" meId="5000000000001" source={subscribers} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="ui-collab-my-work" style={{ minHeight: '100vh', background: 'var(--primary-background-color)' }}>
      <MyWorkPage source={myWork} onOpenItem={() => undefined} />
    </div>
  );
}
